import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12775 18637"
    {...props}
  >
    <path
      d="M11025 2867H3712v4685h6114c563 0 990 128 1267 380 278 256 419 597 419 1020 0 426-141 764-423 1015-286 252-708 376-1263 376H3712v6033c0 768-175 1335-520 1707-346 371-790 554-1327 554-551 0-999-187-1345-563-345-376-520-943-520-1698V2274c0-533 81-968 239-1305s405-585 742-739C1318 77 1749 0 2274 0h8751c593 0 1033 132 1319 393 286 264 431 610 431 1032 0 435-145 785-431 1050-286 260-726 392-1319 392z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
